import React, { useState, useEffect } from "react";
import {
  DialogTitle,
  Autocomplete,
  FormControl,
  FormControlLabel,
  DialogContent,
  DialogActions,
  Dialog,
  Grid,
  InputAdornment,
  Switch,
  TextField,
  IconButton,
  Button,
  DataGrid,
  MaskedInput,
  Loading,
  Select,
  MenuItem,
} from "../../../../components";
import {
  EnderecoService,
  notification,
  PessoaService,
} from "../../../../services";
import { enderecoValidator } from "../middlewares";
import { value } from "../../../../helpers";
import { cacheApi, responseErros } from "../../../../utils";
import shortid from "shortid";

export default function Enderecos(props) {
  const colunas = [
    { field: "descricao", headerName: "Descrição", sortable: false, flex: 500 },
    { field: "cep", headerName: "CEP", sortable: false, flex: 500 },
    {
      field: "logradouro",
      headerName: "Endereço",
      sortable: false,
      flex: 1000,
    },
    { field: "numero", headerName: "Número", sortable: false, flex: 500 },
    { field: "bairro", headerName: "Bairro", sortable: false, flex: 500 },
    {
      field: "cidade",
      headerName: "Cidade",
      sortable: false,
      flex: 500,
      valueGetter: (params) => params.row.cidade?.nome || "",
    },
    {
      field: "paisId",
      headerName: "País",
      sortable: false,
      flex: 400,
      valueGetter: (params) =>
        value.autoComplete(paises || [], params.value)?.nome || "Brasil",
    },
    {
      field: "padrao",
      headerName: "Padrão",
      sortable: false,
      flex: 500,
      valueGetter: (params) => (params.value == true ? "Sim" : "Não"),
    },
  ];
  const [loading, setLoading] = useState(false);
  const enderecoService = new EnderecoService();
  const [estados, setEstados] = useState([]);
  const [cidades, setCidades] = useState([]);
  const [paises, setPaises] = useState([]);
  const [ufId, setUfId] = useState(null);
  const [cidadeId, setCidadeId] = useState(null);
  const [paisId, setPaisId] = useState(null);
  const [endereco, setEndereco] = useState({
    padrao: true,
    tipoInscricaoEstadual: "PRIMARIA",
  });
  const pessoaService = new PessoaService();

  useEffect(() => {
    buscaEnderecos();
    buscaEstados();
    buscarPaises();
  }, []);

  const buscaEstados = async () => {
    const cacheBody = {
      timeMinutes: 60,
      apiFunction: enderecoService.getEstados(),
      dto: { cacheDto: props.cacheDto, setCacheDto: props.setCacheDto },
    };
    const res = await cacheApi(`${enderecoService.urlBase}/estados`, cacheBody);
    if (!res.isAxiosError) {
      setEstados(res.data);
    } else {
      responseErros(res);
    }
  };

  const buscarPaises = async () => {
    const cacheBody = {
      timeMinutes: 60,
      apiFunction: enderecoService.getPaises(),
      dto: { cacheDto: props.cacheDto, setCacheDto: props.setCacheDto },
    };
    const res = await cacheApi(`${enderecoService.urlBase}/paises`, cacheBody);
    if (!res.isAxiosError) {
      setPaises(res.data);
    } else {
      responseErros(res);
    }
  };

  const buscaEnderecos = () => {
    if (props.id) {
      pessoaService.getEnderecos(props.id).then((res) => {
        if (!res.isAxiosError) {
          props.setEnderecosLista(res.data);
        } else {
          responseErros(res);
        }
      });
    }
  };

  const changeCidadesByEstadoId = async (id) => {
    if (id) {
      enderecoService.getCidades(id).then((response) => {
        if (!response.isAxiosError) {
          if (!response.data) {
            notification.erroValidacao("Preencha um estado");
          } else {
            setCidades(response.data);
          }
        } else {
          responseErros(response);
        }
      });
    }
  };

  const handleEstadoUfInput = async (e, newValue) => {
    e.persist();
    setUfId(newValue?.id || null);
    if (newValue?.id) {
      changeCidadesByEstadoId(newValue.id);
    }
  };

  const handleCidadeInput = (e, newValue) => {
    e.persist();
    setCidadeId(newValue?.id || null);
  };

  const handlePaisInput = (e, newValue) => {
    e.persist();
    setPaisId(newValue?.id || null);
  };

  const handleClose = () => {
    props.setOpenEndereco(false);
    setPaisId(null);
  };

  const onClickEditEnderecos = (id) => {
    const enderecoBusca = props.enderecosLista.find((item) => item.id === id);
    if (enderecoBusca) {
      if (props.id) {
        changeCidadesByEstadoId(enderecoBusca.cidade?.estadoId);
        setCidadeId(enderecoBusca.cidade?.id);
        setUfId(enderecoBusca.cidade?.estadoId);
        setEndereco({
          id: enderecoBusca.id,
          cep: enderecoBusca.cep?.toString() || "",
          logradouro: enderecoBusca.logradouro,
          numero: enderecoBusca.numero,
          bairro: enderecoBusca.bairro,
          complemento: enderecoBusca.complemento,
          descricao: enderecoBusca?.descricao,
          padrao: enderecoBusca.padrao,
          exterior: enderecoBusca.exterior || false,
          tipoInscricaoEstadual:
            enderecoBusca.tipoInscricaoEstadual || "PRIMARIA",
        });
        setPaisId(enderecoBusca.paisId || null);
      } else {
        changeCidadesByEstadoId(enderecoBusca?.estadoId);
        setEndereco(enderecoBusca);
        setCidadeId(enderecoBusca?.cidadeId);
        setUfId(enderecoBusca?.estadoId);
      }
      props.setOpenEndereco(true);
    }
  };

  const onClickDeleteEndereco = async (id) => {
    const endereco = props.enderecosLista.find((item) => item.id === id);
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir o endereço: ${endereco.logradouro}, ${endereco.numero}?`,
    );
    if (retornoAlerta.isConfirmed) {
      if (props.id) {
        setLoading(true);
        const res = await enderecoService.deleteEnderecoPessoa(endereco.id);
        if (!res.isAxiosError) {
          props.setEnderecosLista((prevState) => {
            return prevState.filter((endereco) => endereco.id != id);
          });
          notification.deletadoSucesso();
        } else {
          responseErros(res);
        }
        setLoading(false);
      } else {
        props.setEnderecosLista((prevState) => {
          return prevState.filter((endereco) => endereco.id != id);
        });
      }
    }
  };

  const handleClickOpen = async () => {
    setEndereco({ padrao: true });
    setCidadeId(null);
    setUfId(null);
    setCidades([]);
    props.setOpenEndereco(true);
  };

  const handleChangeInput = (event) => {
    setEndereco({
      ...endereco,
      [event.target.name]: event.target.value ? event.target.value : undefined,
    });
  };

  const handleCompletarEndereco = async () => {
    setLoading(true);
    const res = await enderecoService.getByCep(endereco.cep.slice(0, 9));
    if (!res.isAxiosError) {
      setUfId(res.data.estado?.id);
      changeCidadesByEstadoId(res.data.estado?.id);
      setCidadeId(res.data.id);
      setEndereco({
        ...endereco,
        estadoId: res.data.estado?.id,
        bairro: res.data.bairro,
        logradouro: res.data.logradouro,
        cidade: res.data.nome,
        estado: res.data.estado?.sigla,
      });
    } else if (res.response.data.errors.length >= 5) {
      setEndereco({});
      setCidadeId(null);
      setUfId(null);
      setCidades([]);
      notification.alertaGenericos("CEP não encontrado.");
    } else responseErros(res);
    setLoading(false);
  };

  const onClickSalvar = (event) => {
    event.preventDefault();
    if (endereco.id) {
      atualizar();
    } else {
      salvar();
    }
  };

  const montarEnderecoBody = () => {
    return {
      ...endereco,
      exterior: endereco.exterior ? true : false,
      logradouro: endereco.logradouro?.trimStart().trimEnd() || null,
      numero: endereco.numero?.trimStart().trimEnd() || null,
      bairro: endereco.bairro?.trimStart().trimEnd() || null,
      complemento: endereco.complemento?.trimStart().trimEnd() || null,
      cep: endereco.cep?.replace(/[^0-9]/g, "") || null,
      cidadeId: endereco.cidadeId || cidadeId,
      paisId: endereco.exterior ? paisId : null,
      inscricaoEstadual: endereco.inscricaoEstadual || "PRIMARIA",
    };
  };

  const atualizar = async () => {
    const body = montarEnderecoBody();
    enderecoValidator
      .validate(body, { abortEarly: false })
      .then(async () => {
        const cidadeSelecionada = cidades.find(
          (cidade) => cidade.id == cidadeId,
        );
        if (props.id) {
          body.pessoaId = props.id;
          setLoading(true);
          const res = await enderecoService.atualizar(endereco.id, body);
          if (!res.isAxiosError) {
            notification.alteracaoSucesso();
            props.setEnderecosLista((prevState) => [
              ...prevState.map((state) => {
                if (state.id == body.id) {
                  return {
                    ...body,
                    cidade: cidadeSelecionada,
                    id: shortid.generate(),
                  };
                } else return state;
              }),
            ]);
            props.setOpenEndereco(false);
          } else {
            responseErros(res);
          }
          setLoading(false);
        } else {
          props.setEnderecosLista((prevState) =>
            prevState.map((state) => {
              if (state.id == endereco.id) {
                return {
                  ...body,
                  cidade: cidadeSelecionada.nome,
                };
              }
              return state;
            }),
          );
          props.setOpenEndereco(false);
        }
      })
      .catch((err) => {
        props.inputErros?.set(err);
      });
  };

  const salvar = async () => {
    const body = montarEnderecoBody();
    enderecoValidator
      .validate(body, { abortEarly: false })
      .then(async () => {
        const cidadeSelecionada = cidades.find(
          (cidade) => cidade.id == cidadeId,
        );
        if (props.id) {
          body.pessoaId = props.id;
          setLoading(true);
          const res = await pessoaService.cadastrarEndereco(props.id, body);
          if (!res.isAxiosError) {
            notification.cadastroSucesso();
            props.setEnderecosLista((prevState) => [
              ...prevState,
              {
                ...body,
                cidade: cidadeSelecionada,
                id: shortid.generate(),
              },
            ]);
            props.setOpenEndereco(false);
          } else {
            responseErros(res);
          }
          setLoading(false);
        } else {
          const enderecosListaTemp = [
            ...props.enderecosLista,
            {
              ...body,
              cidade: cidadeSelecionada?.nome,
              id: shortid.generate(),
            },
          ];
          props.setEnderecosLista(enderecosListaTemp);
          props.setOpenEndereco(false);
        }
      })
      .catch((err) => {
        props.inputErros?.set(err);
      });
  };

  const handleChangeSwitch = (event) => {
    let enderecoTemp = {
      ...endereco,
      [event.target.name]: event.target.checked,
    };
    if (event.target.name === "exterior" && event.target.checked) {
      setCidadeId(null);
      setUfId(null);
      setCidades([]);
      enderecoTemp = { [event.target.name]: event.target.checked };
    } else setPaisId(null);
    setEndereco(enderecoTemp);
  };

  const inscricoes = {
    inscricaoEstadual: props.pessoa?.inscricaoEstadual,
    inscricaoEstadual2: props.pessoa?.inscricaoEstadual2,
    inscricaoEstadualRural: props.pessoa?.inscricaoEstadualRural,
    inscricaoEstadualRural2: props.pessoa?.inscricaoEstadualRural2,
  };
  const inscricoesUnicas = Object.keys(inscricoes).filter(
    (key) => inscricoes[key],
  );

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} className="mb-3">
          <span className="fw-bold fw-bolder">ENDEREÇOS</span>
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            rows={props.enderecosLista}
            columns={colunas}
            onClickEdit={(id) => {
              onClickEditEnderecos(id);
            }}
            noFilter
            editShow={true}
            deleteShow={true}
            rowCount={props.enderecosLista.length}
            onClickDelete={(id) => onClickDeleteEndereco(id)}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            onClick={() => handleClickOpen()}
            color="primary"
            variant="contained"
          >
            <i
              className="ph-fill ph-plus-circle"
              style={{ color: "#fff", fontSize: 22, marginRight: 10 }}
            ></i>{" "}
            Adicionar
          </Button>
        </Grid>
      </Grid>
      <React.Fragment>
        <Dialog
          fullWidth
          maxWidth="md"
          open={props.openEndereco}
          onClose={handleClose}
        >
          <form onSubmit={(e) => e.preventDefault()}>
            <DialogTitle>Cadastrar Endereço</DialogTitle>
            <DialogContent>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={4}>
                  <MaskedInput
                    mask="99999-999"
                    id="cep"
                    name="cep"
                    label="CEP"
                    required
                    disabled={endereco.exterior ? true : false}
                    error={props.inputErros?.get("cep")}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="Pesquisar CEP"
                            disabled={endereco.exterior ? true : false}
                            onClick={() => handleCompletarEndereco()}
                          >
                            <i
                              className="ph-bold ph-magnifying-glass"
                              style={{ color: "#494C62", fontSize: 18 }}
                            ></i>
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    value={endereco.cep ? endereco.cep : ""}
                    onInput={handleChangeInput}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleCompletarEndereco();
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    id="logradouro"
                    name="logradouro"
                    label="Endereço"
                    variant="outlined"
                    error={props.inputErros?.get("logradouro")}
                    margin="normal"
                    type="text"
                    value={endereco.logradouro ? endereco.logradouro : ""}
                    onChange={(event) => handleChangeInput(event)}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    id="numero"
                    name="numero"
                    label="Número"
                    variant="outlined"
                    error={props.inputErros?.get("numero")}
                    value={endereco.numero ? endereco.numero : ""}
                    onChange={(event) => handleChangeInput(event)}
                    margin="normal"
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    id="bairro"
                    name="bairro"
                    label="Bairro"
                    variant="outlined"
                    required
                    margin="normal"
                    error={props.inputErros?.get("bairro")}
                    value={endereco.bairro ? endereco.bairro : ""}
                    onChange={(event) => handleChangeInput(event)}
                    type="text"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    id="complemento"
                    name="complemento"
                    label="Complemento"
                    variant="outlined"
                    margin="normal"
                    disabled={endereco.exterior ? true : false}
                    value={endereco.complemento ? endereco.complemento : ""}
                    onChange={(event) => handleChangeInput(event)}
                    type="text"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormControl variant="outlined" margin="normal" fullWidth>
                    <Autocomplete
                      required
                      id="estado"
                      name="estado"
                      options={estados}
                      noOptionsText="Sem opções"
                      autoHighlight
                      disabled={endereco.exterior ? true : false}
                      getOptionLabel={(option) =>
                        option.sigla && option.nome
                          ? `${option.sigla} - ${option.nome}`
                          : ""
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="UF"
                          required
                          variant="outlined"
                          error={props.inputErros?.get("bairro")}
                        />
                      )}
                      onChange={(event, newValue) =>
                        handleEstadoUfInput(event, newValue)
                      }
                      value={value.autoComplete(estados, ufId)}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl variant="outlined" margin="normal" fullWidth>
                    <Autocomplete
                      required
                      id="cidade"
                      name="cidade"
                      options={cidades}
                      noOptionsText="Sem opções"
                      autoHighlight
                      disabled={endereco.exterior ? true : false}
                      getOptionLabel={(option) =>
                        option.nome ? option.nome : ""
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Cidade"
                          required
                          variant="outlined"
                          error={props.inputErros?.get("cidade")}
                        />
                      )}
                      onChange={(event, newValue) => {
                        handleCidadeInput(event, newValue);
                      }}
                      value={value.autoComplete(cidades, cidadeId)}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    id="descricao"
                    name="descricao"
                    label="Descrição"
                    variant="outlined"
                    margin="normal"
                    value={endereco?.descricao ? endereco.descricao : ""}
                    onChange={(event) => handleChangeInput(event)}
                    placeholder="APTO, Casa, Trabalho..."
                    type="text"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={2}>
                  <FormControlLabel
                    label="Padrão"
                    control={
                      <Switch
                        id="padrao"
                        name="padrao"
                        disabled={endereco.exterior ? true : false}
                        checked={endereco.padrao ? true : false}
                        onChange={handleChangeSwitch}
                        color="primary"
                      />
                    }
                  />
                </Grid>
                <Grid item xs={2}>
                  <FormControlLabel
                    label="Exterior"
                    control={
                      <Switch
                        id="exterior"
                        name="exterior"
                        checked={endereco.exterior ? true : false}
                        onChange={handleChangeSwitch}
                        color="primary"
                      />
                    }
                  />
                </Grid>
                {endereco.exterior && (
                  <>
                    <Grid item xs={4}>
                      <FormControl variant="outlined" margin="normal" fullWidth>
                        <Autocomplete
                          required
                          id="pais"
                          name="pais"
                          options={paises}
                          noOptionsText="Sem opções"
                          autoHighlight
                          getOptionLabel={(option) =>
                            option.nome ? option.nome : ""
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="País"
                              required
                              variant="outlined"
                              error={props.inputErros?.get("pais")}
                            />
                          )}
                          onChange={(event, newValue) => {
                            handlePaisInput(event, newValue);
                          }}
                          value={value.autoComplete(paises, paisId)}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id="bacen"
                        name="bacen"
                        label="Bacen"
                        variant="outlined"
                        margin="normal"
                        disabled
                        value={value.autoComplete(paises, paisId)?.codigo || ""}
                        type="text"
                        fullWidth
                      />
                    </Grid>
                  </>
                )}
                {inscricoesUnicas?.length > 1 && (
                  <Grid item xs={4}>
                    <Select
                      id="tipoInscricaoEstadual"
                      name="tipoInscricaoEstadual"
                      label="Inscrição Estadual"
                      value={endereco?.tipoInscricaoEstadual}
                      onChange={(e) => {
                        setEndereco({
                          ...endereco,
                          tipoInscricaoEstadual: e.target.value,
                        });
                      }}
                      fullWidth
                      variant="outlined"
                    >
                      {inscricoesUnicas.map((inscricao) => (
                        <MenuItem
                          key={inscricao}
                          value={
                            inscricao.includes("2") ? "SECUNDARIA" : "PRIMARIA"
                          }
                        >
                          {inscricoes[inscricao]}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                )}
              </Grid>
            </DialogContent>
            <DialogActions className="d-flex flex-row justify-content-end m-3">
              <Button
                onClick={() => handleClose()}
                variant="contained"
                color="padrao"
              >
                <i
                  className="ph-fill ph-x-circle"
                  style={{ fontSize: 22, marginRight: 10 }}
                ></i>
                Cancelar
              </Button>
              <Button
                onClick={(event) => onClickSalvar(event)}
                variant="contained"
                color="primary"
              >
                <i
                  className="ph-fill ph-check-circle"
                  style={{ color: "white", fontSize: 22, marginRight: 10 }}
                ></i>
                Salvar
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </React.Fragment>
      <Loading loading={loading} />
    </>
  );
}
